import * as Yup from 'yup';
import { HazardousActivities } from '../../models/enums';

export const InitEventInformation = {
  eventName: 'Event name',
  eventType: '',
  from: '',
  to: '',
  locationName: '',
  locationType: '',
  EventAddress: '',
  setupDescription: '',
  emergencyService: '',
  hazardousActivities: '', 
}

export const SchemaEventInformation = Yup.object().shape({
    eventName: Yup.string().required("*"),
    eventType: Yup.string().required("*"),
    from: Yup.date(),
    to: Yup.date(),
    locationName: Yup.string(),
    locationType: Yup.string(),
    EventAddress: Yup.string(),
    setupDescription: Yup.string(),
    emergencyService: Yup.string(),
    hazardousActivities: Yup.string(), 
  })